import { LabelBinding, PersonalOfferProductsRequest } from '@monorepo-types/dc/sales';

import { request } from '../../client';
import type { ApiRequestConfig } from '../../client/types';

type PostV1SalesPublicAccountsOfferPersonalProducts = {
  label: LabelBinding;
  customerId: number;
  accountId: number;
  requestBody: PersonalOfferProductsRequest;
};
/**
 *
 *
 * @returns void
 */
export function postV1SalesPublicAccountsOfferPersonalProducts(
  { label, customerId, accountId, requestBody }: PostV1SalesPublicAccountsOfferPersonalProducts,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'POST',
      path: `/v1/sales/public/${label}/${customerId}/accounts/${accountId}/offer-personal-products`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
